import { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GenericTable from "components/CRPComponents/Tables/GenericTable";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import { ListProps } from "./types";
import { CellProps, GET_ALL_QUERY, GetAllGql, GetAllItem, QueryArgs } from "./queries/getAll";
import { ApiAuthWithSetData } from "data/ApiForm";
import MDInput from "components/MDInput";
import { MenuItem } from "@mui/material";
import { AnalysisButton } from "../BlogComments/styles";
import { useNavigate } from "react-router-dom";
import { PublicViewButton } from "../publicView";

function List(props: ListProps) {
  const navigate = useNavigate();

  const [filters, setFilters] = useState<QueryArgs>({
    status: null,
    isDefaultForm: false,
    formType: "DINAMIC",
    page: null,
    perPage: null,
    search: null,
  });

  const [tableKey, setTableKey] = useState(0);

  const handleFilterChange = (key: keyof QueryArgs, value: any) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    setTableKey((prev) => prev + 1);
  }, [filters]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <GenericTable<GetAllGql>
        key={tableKey}
        initialVariables={filters}
        path={`${props.path}/forms`}
        query={GET_ALL_QUERY}
        formatRows={(data) => data.Forms.items}
        formatPagination={(data) => data.Forms?.paginationInfo}
        title="NOVO FORMULÁRIO"
        ApiSetData={ApiAuthWithSetData}
        useDefaultFilter={false}
        childrenFilters={
          <>
            <MDInput
              value={filters.status}
              label="Status"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleFilterChange("status", e.target.value)
              }
              sx={{ width: "130px" }}
              select
            >
              <MenuItem value={null}>Todos</MenuItem>
              <MenuItem value="ACTIVE">Ativos</MenuItem>
              <MenuItem value="INACTIVE">Inativos</MenuItem>
              <MenuItem value="DRAFT">Rascunho</MenuItem>
            </MDInput>

            <MDInput
              value={filters.formType}
              label="Tipo de formulário"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                handleFilterChange("formType", e.target.value)
              }
              sx={{ width: "200px" }}
              select
            >
              <MenuItem value="DINAMIC">Dinâmico</MenuItem>
              <MenuItem value="EVENT">Eventos</MenuItem>
            </MDInput>
          </>
        }
        columnsTable={[
          {
            Header: "id",
            accessor: "id",
            Cell: ({ value }: any) => (
              <LinkCell href={`${props.path}/forms/${value}`} value={value} />
            ),
          },
          {
            Header: "Slug",
            accessor: "slug",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Título",
            accessor: "title",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Status",
            accessor: "status",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Tipo de formulário",
            accessor: "formType",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Ver",
            accessor: "preview",
            Cell: ({ row }: any) => (
              <PublicViewButton
                category="formulario"
                status={row.original.status}
                slug={row.original.slug}
                publishOn={row.original.publishOn}
              />
            ),
          },
          {
            Header: "Repostas",
            accessor: "",
            Cell: ({ value, cell }: CellProps) => (
              <AnalysisButton
                onClick={() => navigate(`${props.path}/forms/${cell.row.original.slug}/entries`)}
              >
                Visualizar
              </AnalysisButton>
            ),
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
